/**
 * 정식 주소 전환 상태 — 운영 Worker 의 대표 주소 전환 키(KV)가 켜졌는지만 읽는다(`/api/domain-rollout`).
 * 켜져 있으면 1.0 의 옛 두 주소(unige.flowlabs.ai.kr · game.flowlabs.ai.kr)에서 만든 초대 링크도 정식 주소 unige.ai.kr 로 낸다
 * (`canonicalInviteOrigin` — 도움말 패널 · 주소 표는 `launch-hosts.js`).
 *
 * 2026-10-18 — 시작·게임 화면의 주소 변경 안내(옛 주소의 「주소가 바뀌었다」 카드, 정식 주소의 [기존 캐릭터 가져오기] 와 계정 안내 카드,
 * 옛 주소 계정 이전 창 `/account-transfer.html`)는 사용자 지시로 걷어냈다(「언제까지 주소 바뀐거랑 구구절절 런칭 메세지 남겨둘거야?」 ·
 * DESIGN 14.596). 옛 주소의 게스트 계정은 그 주소에서 그대로 이어 한다(같은 운영 Worker · 같은 D1).
 */
import { CANONICAL_ORIGIN, LEGACY_HOSTS } from './launch-hosts.js';

let enabled = false;

export function canonicalInviteOrigin() {
  return enabled && LEGACY_HOSTS.includes(location.hostname) ? CANONICAL_ORIGIN : location.origin;
}

/** 옛 주소에서만 전환 키를 읽는다 — 정식 주소의 초대 링크는 원래 자기 주소라 읽을 것이 없다 */
export async function initDomainRollout() {
  if (!LEGACY_HOSTS.includes(location.hostname)) return;
  try {
    const response = await fetch('/api/domain-rollout', { cache: 'no-store' });
    if (!response.ok) return;
    enabled = (await response.json()).enabled === true;
    if (enabled) window.dispatchEvent(new Event('unige:domain-rollout'));
  } catch { /* 못 읽으면 지금 주소로 초대한다 */ }
}
